<template>
  <div>
    <transition name="slide-fade">
      <v-toolbar fixed light class="mini-shopping-basket align-center" v-if="showNav">
        <img v-if="company && logoImage" class="mobile-card" :src="logoImage" style="max-height: 42px; max-width: 120px; background-position: unset;" alt="Logo">
        <h5 :class="{'short-name': true, 'desktop-card': logoImage}" v-if="company">{{ company.name }}</h5>
        <v-spacer/>
        <v-layout row align-center justify-end style="height: 56px">
          <div class="text-xs-right">
            <span class="mb-0">{{ $lang.labels.total }}:</span>
            <span class="price no-min" :data-currency="company ? company.currencySymbol : '₤'">{{ total.toFixed(2) }}</span>
          </div>
          <v-btn class="elevation-0 sticky-button" color="primary" @click="headerSubmit">{{ $lang.actions.checkout }}</v-btn>
        </v-layout>
      </v-toolbar>
    </transition>
    <h2 class="mb-4">{{ $lang.global.shoppingBasket }}</h2>
    <v-layout column ref="shoppingBasket">
      <v-flex xs12>
        <v-layout row wrap justify-start class="">
          <v-flex class="sub-header">
            <p class="inline">{{ $lang.global.deliveryMethod }}:</p>
          </v-flex>
          <v-flex class="radio-wrap">
            <v-radio-group @change="setOrderType" v-model="orderType" class="pt-0">
              <v-layout v-if="company" row wrap justify-start align-center class="radio-wrap pt-0">
                <v-flex v-for="(type, index) in company.orderTypes" :key="index">
                  <v-radio
                      type="radio"
                      :label="$lang.actions[type]"
                      :value="type"
                      class="single-radio"/>
                </v-flex>
              </v-layout>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-layout column v-if="orderType === 'delivery'">
        <v-layout row wrap v-if="isLoggedIn()">
          <v-flex xs12>
            <v-select
                :items="addressesForLoggedInUser"
                v-model="selectAddress"
                :label="$lang.labels.selectAddress"
                single-line
            ></v-select>
          </v-flex>
        </v-layout>
        <v-flex xs12 v-if="!isLoggedIn() || showAddressFields">
          <v-layout row wrap align-center class="mb-4">
            <address-at v-if="company && company.address.country === 'AT'" :address="chosenAddress" :fromBack="fromBack" @submit="submitAddress" @resetFromBack="resetFromBack()"/>
            <address-uk v-if="company && company.address.country === 'UK'" :address="chosenAddress" :fromBack="fromBack" @submit="submitAddress" @resetFromBack="resetFromBack()"/>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="v-table__overflow mb-4 " v-if="cart.length > 0">
        <table class="v-datatable v-table px-0">
          <thead class="pb-2">
          <tr :style="goDark ? 'background-color: #424242; color: white' : ''">
            <th role="columnheader" scope="col" class="column total text-xs-left pl-3">{{ $lang.labels.quantity }}</th>
            <th colspan="2" role="columnheader" scope="col" class="column total text-xs-left pl-1">{{ $lang.labels.name }}
            </th>
            <th role="columnheader" scope="col" class="column total text-xs-right pr-3">{{ $lang.labels.total }}</th>
          </tr>
          <tr class="v-datatable__progress">
            <th colspan="100%" class="column"></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, index) in cart">
            <tr :key="index" class="item" :style="goDark && index %2 ? 'background-color: #303030' : ''">
              <td class="text-xs-left pa-3" style="min-width: 110px;width: 110px;">
                <v-btn dark small color="primary mx-0 my-btn" @click="editQuantity(index, 'dec')">
                  <v-icon dark>remove</v-icon>
                </v-btn>
                <span class="quantity">{{ item.quantity }}</span>
                <v-btn dark small color="accent mx-0 my-btn" @click="editQuantity(index, 'asc')">
                  <v-icon id="addMore" dark>add</v-icon>
                </v-btn>
              </td>
              <td colspan="2" class="text-xs-left py-3 px-1">{{
                  item.name[$lang.current_lang] ? item.name[$lang.current_lang] : item.name.en
                }}<br>
                <span :style="goDark ? 'color: #ffffffb3' : ''"  class="flex py-2 xs4 details" v-if="item.selectedSize.name && !item.selectedSize.isDefault">{{ $lang.labels.size }}: {{
                    item.selectedSize.name[$lang.current_lang] ? item.selectedSize.name[$lang.current_lang] : item.selectedSize.name.en
                  }}
                </span>
                <span :style="goDark ? 'color: #ffffffb3' : ''" class="flex py-2 xs4 details" v-if="item.selectedStyle.name  && !item.selectedStyle.isDefault"><span v-if="item.selectedSize.name && !item.selectedSize.isDefault">,&nbsp</span> {{ $lang.labels.style }}: {{
                    item.selectedStyle.name[$lang.current_lang] ? item.selectedStyle.name[$lang.current_lang] : item.selectedStyle.name.en
                  }}
                </span>
                <span :style="goDark ? 'color: #ffffffb3' : ''" class="flex py-2 xs4 details" v-if="item.selectedVariants && item.selectedVariants.name  && !item.selectedVariants.isDefault">
                  <span v-if="(item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault)">,&nbsp</span>
                  {{ $lang.labels.variant }}: {{
                    item.selectedVariants.name[$lang.current_lang] ? item.selectedVariants.name[$lang.current_lang] : item.selectedVariants.name.en
                  }}
                </span>
                <span :style="goDark ? 'color: #ffffffb3' : ''" class="flex py-2 xs4 details" v-if="item.selectedOptions.length > 0">
                  <span v-if="(item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault) || (item.selectedVariants.name && !item.selectedVariants.isDefault)">,&nbsp</span>{{ $lang.labels.options }}:
                    <span v-for="(option, index) in item.selectedOptions" :key="index">
                      <span v-if="item.selectedOptions.length > 1 && index !== 0">,&nbsp</span>
                      {{ option.name[$lang.current_lang] ? option.name[$lang.current_lang] : option.name.en }} x
                      {{ option.quantity }}
                    </span>
                </span><br v-if="item.allergens && item.allergens.length > 0">
                <span class="flex py-2 xs4 orangeTheme details" v-if="item.allergens && item.allergens.length > 0"><span
                    class="pointerCursor"
                    @click="openAllergens(item.allergens)">
                  {{ $lang.labels.showAllergens }}
                </span></span>
                <br v-if="item.comment">
                <span :style="goDark ? 'color: white' : ''" class="flex py-2 xs12 details" v-if="item.comment">{{ $lang.labels.comment }}: {{ item.comment }}</span>
              </td>
              <td class="text-xs-right pa-3 details"><p :style="goDark ? 'color: white' : ''" class="price" :data-currency="company ? company.currencySymbol : '₤'">{{
                  $store.state.calculatePrice(item.selectedSize, item.selectedVariants, item.selectedOptions, item.quantity, item.quantityOfIncludedOptions)
                      .toFixed(2)
                }}</p></td>
            </tr>
          </template>
          <tr v-if="deliveryCharges !== null && deliveryCharges > 0">
            <td class="text-xs-left" style="min-width: 110px; padding-left: 45px">
              <span class="quantity">1</span>
            </td>
            <td colspan="2" class="text-xs-left py-3 px-1">{{ $lang.labels.deliveryCharges }}</td>
            <td class="text-xs-right py-3 px-3"><span :style="goDark ? 'color: white' : ''" class="price" :data-currency="company ? company.currencySymbol : ''">
              {{ deliveryCharges.toFixed(2) }}</span></td>
          </tr>
          </tbody>
        </table>
      </div>
      <v-layout column>
        <v-flex xs12>
          <v-alert
              color="success"
              class="success display-1 text-center text-xs-center"
              value="true"
              v-if="success && width > 599">{{ success }}<br>
            <span class="headline"
                  style="letter-spacing: 3px !important;"><small>{{ $lang.labels.total }}: {{ company.currencySymbol }}{{ total.toFixed(2) }}</small></span>
          </v-alert>
          <v-alert
              color="success"
              class="success notifications text-left text-xs-left"
              value="true"
              icon="add"
              v-if="success && width < 600">{{ success }}<br>
            <span class="headline"
                  style="letter-spacing: 3px !important;"><small>{{ $lang.labels.total }}: {{ company.currencySymbol }}{{ total.toFixed(2) }}</small></span>
          </v-alert>
          <v-alert
              color="error"
              class="err"
              icon="warning"
              value="true"
              v-if="err">{{ err }}
          </v-alert>
          <v-alert
              color="warning"
              class="warn"
              icon="warning"
              value="true"
              v-if="warn">{{ warn }}
          </v-alert>
        </v-flex>
        <v-btn
            v-if="orderType === 'delivery' && company &&
            company.minDeliveryAmount && total <
            parseFloat(company.minDeliveryAmount)"
            color="primary"
            dark
            :disabled="!checkAcceptingOrders()">
          {{ $lang.errors.minimalDelivery }}:
          <span :style="goDark ? 'color: white' : ''"
              :data-currency="company ? company.currencySymbol : '₤'"
              class="ml-1 price no-min"
          >{{
              parseFloat(company.minDeliveryAmount)
                  .toFixed(2)
            }}</span>
        </v-btn>
        <v-btn
            v-else-if="closed && remainingWorkingRanges.length > 0"
            type="submit"
            color="primary"
            @click="submit()"
            :disabled="!checkAcceptingOrders()"
        >{{ $lang.actions.preorder }}
        </v-btn>
        <v-btn
            v-else
            type="submit"
            dark
            color="primary mx-0"
            @click="submit()"
            :disabled="!checkAcceptingOrders()"
        >
          <span v-if="company && company.currencyPosition !== 'right' && total" class="mr-2">{{ company ? company.currencySymbol + total.toFixed(2) : '' }}</span>
          {{ $lang.actions.checkout }}
          <span v-if="company && company.currencyPosition === 'right' && total" class="ml-2">{{ company ? total.toFixed(2) + company.currencySymbol : '' }}</span>
        </v-btn>
        <v-textarea
            class="pt-4"
            :label="$lang.labels.comment"
            name="comment"
            v-model="comment"
            :rules="commentRules"
            @blur="$store.dispatch('setComment', $event.target.value.substring(0, 1024))"
            rows="1"
            auto-grow
        />
      </v-layout>
    </v-layout>
    <v-dialog scrollable :fullscreen="width < 768" v-model="allergensDialog" v-if="allergensDialog"
              max-width="200px">
      <Allergens @close="closeDialog('allergens')" :allergens="allergens" :catalogAllergens="catalog.allergens"/>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import auth from '@/auth';
import AddressAt from '@/components/webshop/modals/AddressSearchAt';
import AddressUk from '@/components/webshop/modals/AddressSearchUk';
import Allergens from '@/components/webshop/modals/Allergens';

export default {
  components: {
    AddressAt,
    AddressUk,
    Allergens,
  },
  props: ['successMessage'],
  data() {
    return {
      isLoadingAddress: false,
      isLoading: false,
      showNav: false,
      orderType: '',
      postalcode: '',
      line1: '',
      comment: '',
      err: '',
      warn: '',
      success: '',
      successPostal: '',
      deliveryCharges: null,
      distanceInMiles: 0,
      total: 0,
      itemsTotal: 0,
      isValid: false,
      validPostal: null,
      selectAddress: null,
      selectAddressAT: null,
      calcTimeout: null,
      latitude: null,
      longitude: null,
      resourceId: null,
      commentRules: [v => (!v || v.length < 1025) || this.$lang.errors.commentShorter],
      postalCodes: [],
      search: null,
      searchAddress: null,
      hint: '',
      fromBack: false,
      chosenAddress: undefined,
      allergensDialog: false,
      allergens: [],
      showAddressFields: false,
      successTimeout: null,
    };
  },
  computed: {
    ...mapGetters({
      isFetchingUser: 'isFetchingUser',
      orderInfo: 'orderInfo',
      cart: 'cart',
      addresses: 'addresses',
      addressesAT: 'addressesAT',
      addressesSet: 'addressesSet',
      company: 'company',
      closedMessage: 'closedMessage',
      closed: 'closed',
      remainingWorkingRanges: 'remainingWorkingRanges',
      savedpostalCode: 'postalCode',
      storedComment: 'comment',
      width: 'width',
      catalog: 'catalog',
      goDark: 'goDark',
    }),
    postalCodeRules() {
      if (this.company && this.postalcode) {
        if (this.testPostalCodeRules(this.company.address.country, this.postalcode) !== true) this.startErrorAnimation('elPostalAutocomplete');
        return this.testPostalCodeRules(this.company.address.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    addressesForLoggedInUser() {
      const tempAddresses = [this.$lang.actions.addAddress];
      this.addresses.forEach((current) => {
        if (current.latitude && current.longitude) {
          tempAddresses.push(this.generateFullAddress(current));
        }
      });
      return tempAddresses;
    },
    logoImage() {
      if (this.company && this.company.htmlHints && this.company.htmlHints.find(x => x.name === 'webshop.logo')) { return this.company.htmlHints.find(x => x.name === 'webshop.logo').value; }
      return false;
    },
  },
  watch: {
    search: {
      handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        this.getPostalCodes(val);
        if (!this.isLoggedIn()) {
          this.removeAddress();
        }
      },
      deep: true,
    },
    searchAddress: {
      handler(val) {
        if (val) {
          this.searchAddress = this.searchAddress.trim();
        }
        // this.getPrefill(this.postalcode);
      },
      deep: true,
    },
    cart: {
      handler() {
        this.$storage.order = this.cart;
        this.bufferCalculation();
      },
      deep: true,
    },
    selectAddress(newValue) {
      if (newValue === null) return;
      if (newValue === undefined) return;
      if (newValue === 'Add address' || newValue === 'Addresse hinzufügen') {
        this.showAddressFields = true;
        this.submitAddress(newValue, true);
        return;
      }
      this.addresses.forEach((current) => {
        if (this.generateFullAddress(current) === newValue) {
          this.submitAddress(current, true);
        }
      });
    },
    selectAddressAT(newValue) {
      if (newValue === null) return;
      this.addressesAT.forEach((current, index) => {
        if (this.generateFullAddressAT(current) === newValue) {
          this.line1 = newValue.split(',')[0].trim();
          this.$store.dispatch('chooseAddress', index);
        }
      });
    },
    postalcode() {
      this.validPostal = null;
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
    },
    err() {
      setTimeout(() => {
        this.err = '';
      }, 5000);
    },
    warn() {
      setTimeout(() => {
        this.warn = '';
      }, 5000);
    },
    success() {
      this.successTimeout = setTimeout(() => {
        this.success = '';
        this.successPostal = false;
      }, 5000);
    },
    successMessage(newVal) {
      if (newVal) {
        clearTimeout(this.successTimeout);
        this.success = newVal;
      }
    },
  },
  methods: {
    closeDialog(type) {
      this.$store.dispatch('setModal', false);
      if (type === 'address') {
        this.addressDialog = false;
      } else if (type === 'allergens') {
        this.allergens = [];
        this.allergensDialog = false;
      } else {
        this.timeDialog = false;
      }
    },
    checkAcceptingOrders() {
      if (this.company) {
        return !!this.company.acceptingOrders;
      }
      return true;
    },
    openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    onBlurPostal() {
      if (this.postalCodes.includes(this.search)) {
        this.postalcode = this.search;
        // this.getPrefill(this.postalcode);
      } else {
        this.startErrorAnimation('elPostalAutocomplete');
      }
    },
    submitAddress(address, fromList = false) {
      if (address === 'Add address' || address === 'Addresse hinzufügen') {
        this.chosenAddress = null;
        this.line1 = null;
        this.latitude = null;
        this.longitude = null;
        this.search = null;
        this.postalCodes = [];
        this.postalcode = '';
        return;
      }
      this.chosenAddress = address;
      this.line1 = address.line1.trim();
      this.latitude = address.latitude;
      this.longitude = address.longitude;
      this.search = address.postalCode ? address.postalCode.toUpperCase() : '';
      this.postalCodes = address.postalCode ? [address.postalCode.toUpperCase()] : [];
      this.postalcode = address.postalCode;
      this.$store.dispatch('addPostal', {
        postalCode: this.postalcode,
        latitude: this.latitude,
        longitude: this.longitude,
      });
      if (address.line1) {
        this.addPostal();
      }
      if (this.isLoggedIn() && !fromList && address.line1 !== '') {
        const tempAddresses = this.addresses;
        tempAddresses.push(address);
        this.$store.dispatch('setAddresses', tempAddresses);
        setTimeout(() => {
          this.selectAddress = this.generateFullAddress(address);
        }, 100);
      }
      this.$store.dispatch('setAddressesAT', [address]);
      this.$store.dispatch('chooseAddress', 0);
    },
    deleteAddress() {
      this.chosenAddress = undefined;
      this.selectAddress = '';
    },
    resetFromBack() {
      if (this.fromBack) {
        this.fromBack = false;
      }
    },
    getPrefill(value) {
      if (!value) return;
      if (this.fromBack) {
        this.fromBack = false;
        return;
      }
      if (this.company.address.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.company.address.country === 'AT' && value.length !== 4) return;
      if ((!value || !this.searchAddress || this.searchAddress.length < 3) && this.company.address.country === 'AT') return;
      if (this.searchAddress && this.searchAddress.split(',').length === 4 && this.company.address.country === 'AT') return;
      const payload = this.company.address.country === 'AT' ?
      // eslint-disable-next-line max-len
        { postalCode: value.toUpperCase(), line1: this.searchAddress, country: this.company.address.country } :
        { postalCode: value.toUpperCase(), country: this.company.address.country };
      if (this.resourceId) {
        this.$webHelper.post(`address/${this.resourceId}`, payload)
          .then((res) => {
            if (res.body && res.status === 200 && res.body.addresses) {
              this.hint = this.$lang.success.postalSet;
              this.latitude = res.body.addresses[0].latitude;
              this.longitude = res.body.addresses[0].longitude;
              this.isLoading = false;
              this.$store.dispatch('addPostal', {
                postalCode: this.postalcode,
                latitude: this.latitude || res.body.addresses[0].latitude,
                longitude: this.longitude || res.body.addresses[0].longitude,
              });
              this.$store.dispatch('setAddressesAT', res.body.addresses);
              if (this.company.address.country === 'UK') this.calcAll(true);
            } else {
              this.hint = res.body.statusText;
              this.isLoading = false;
            }
          })
          .catch((err) => {
            this.err = err;
            this.isLoading = false;
          });
      }
    },
    getPostalCodes(code) {
      if (!code) return;
      code.trim()
        .toUpperCase();
      this.hint = '';
      if (this.company.address.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.company.address.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$webHelper.get(`address/postalcodes/${this.resourceId}`, {
        startswith: code.trim()
          .toUpperCase(),
      })
        .then((res) => {
          if (res.body && res.status === 200) {
            if (res.body.postalCodes.length === 0) {
              this.hint = this.$lang.errors.noPostalFound;
              this.isLoading = false;
            } else {
              if ((res.body.postalCodes.filter(x => x === this.postalcode)).length === 0) {
                this.postalCodes = res.body.postalCodes;
              }
              this.isLoading = false;
            }
          }
        })
        .catch((err) => {
          this.err = err;
          this.isLoading = false;
        });
    },
    setOrderType(event) {
      this.$store.dispatch('setType', event);
      localStorage.setItem('delivery_method', event);
      if (event !== 'delivery') {
        this.distanceInMiles = 0;
        this.deliveryCharges = 0;
      }
    },
    bufferCalculation() {
      if (this.calcTimeout !== null) {
        clearTimeout(this.calcTimeout);
      }
      this.calcTimeout = setTimeout(() => {
        this.calcTimeout = null;
        this.calcAll();
      }, 500);
    },
    headerSubmit() {
      this.$refs.shoppingBasket.scrollIntoView(true);
      this.submit();
    },
    handleScroll() {
      if (window.scrollY > 500) {
        this.showNav = true;
      }
      if (window.scrollY < 500) {
        this.showNav = false;
      }
    },
    isLoggedIn() {
      return auth.isLoggedIn();
    },
    generateAddress(lines) {
      return lines.filter(line => !!line)
        .join(', ');
    },
    generateFullAddress(address) {
      if (address) {
        const lines = this.generateAddress([
          address.line1,
          address.line2,
          address.line3,
          address.line4,
        ]);
        let fullAdderss = lines;
        if (address.locality) {
          fullAdderss += `, ${address.locality}`;
        }
        return `${fullAdderss}, ${address.townCity}, ${address.postalCode}`;
      }
      return '';
    },
    generateFullAddressAT(address) {
      this.latitude = address.latitude;
      this.longitude = address.longitude;
      const lines = this.generateAddress([
        address.line1,
        address.line2,
        address.line3,
        address.line4,
      ]);
      let fullAdderss = lines;
      if (address.locality) {
        fullAdderss += `, ${address.locality}`;
      }
      return `${fullAdderss}, ${address.townCity}, ${this.postalcode}`;
    },
    removeAddress() {
      if (this.search && this.postalcode === this.search.trim()) return;
      this.chosenAddress = undefined;
      this.line1 = '';
      if (this.selectAddress) {
        const tempPostal = this.selectAddress.split(',')[4];
        if (tempPostal.trim() !== this.postalcode) {
          this.selectAddress = null;
          this.$store.dispatch('removeAddress');
        }
      }
    },
    addPostal() {
      return new Promise((resolve) => {
        this.postalcode = this.postalcode.trim()
          .toUpperCase();
        const payload = this.company.address.country === 'UK' ?
        // eslint-disable-next-line max-len
          { postalCode: this.postalcode, country: this.company.address.country } : {
            postalCode: this.postalcode,
            line1: this.line1,
            country: this.company.address.country,
          };
        if (this.company.address.country === 'AT' && !this.line1) {
          this.err = this.$lang.errors.addressAT;
          resolve(false);
          return;
        }
        if (!this.resourceId) return;
        this.$webHelper.post(`address/${this.resourceId}`, payload)
          .then((res) => {
            if (!res.success) throw new Error(this.$lang.errors.invalidPostal);
            this.$store.dispatch('addPostal', {
              postalCode: this.postalcode,
              latitude: this.latitude || res.body.addresses[0].latitude,
              longitude: this.longitude || res.body.addresses[0].longitude,
            });
            this.validPostal = true;
            if (this.cart.length > 0) this.success = this.$lang.success.deliveryCalculated;
            resolve(this.calcAll(true));
          })
          .catch((err) => {
            this.err = err.message || this.$lang.errors.postalValidate;
            resolve(false);
          });
      });
    },
    selectCartItem(index) {
      this.$store.dispatch('selectItem', index);
    },
    editQuantity(index, action) {
      this.$store.dispatch('editCartItemQuantity', { index, action })
        .then(() => {
          this.$storage.order = this.cart;
        });
    },
    calcDelivery() {
      return new Promise((resolve) => {
        if (!this.latitude || !this.longitude) {
          resolve(false);
          return;
        }
        this.calcTotalWithoutDelivery()
          .then((res) => {
            if (res === null) return null;
            return this.$webHelper.post('order/calculatedeliverycharges', {
              country: this.company.address.country,
              latitude: this.latitude,
              longitude: this.longitude,
              postalCode: this.postalcode,
              totalAmount: res,
            }, this.$router);
          })
          .then((res) => {
            if (!res || !res.success) {
              if (res.body && res.body.statusText) {
                if (res.body.statusText === 'CalculateDeliveryCharges: Delivery to the requested Postal Code not configured in the Company.'
                || res.body.statusText === 'CalculateDeliveryCharges: Requested postal code is not allowed') {
                  this.err = this.$lang.errors.codeOutsideArea;
                } else if (res.body.statusText.includes('CalculateDeliveryCharges: ')) {
                  this.err = res.body.statusText.replace('CalculateDeliveryCharges: ', '');
                } else {
                  this.err = res.body.statusText;
                }
              } else {
                this.err = this.$lang.errors.failedCalculate;
              }
              this.validPostal = false;
              this.distanceInMiles = 0;
              this.deliveryCharges = 0;
              resolve(false);
              return;
            }
            this.validPostal = true;
            this.postalcode = this.postalcode.charAt(0)
              .toUpperCase() + this.postalcode.slice(1);
            this.distanceInMiles = res.body.distanceInMiles;
            this.deliveryCharges = res.body.deliveryCharges;
            resolve(true);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    calcTotal() {
      return new Promise((resolve) => {
        if (this.cart.length === 0) {
          this.total = 0;
          resolve();
          return;
        }
        this.$webHelper.post('order/calculatetotalamount', {
          items: this.cart.map((current, index) => {
            const item = current;
            item.itemId = index;
            return item;
          }),
          deliveryCharges: this.deliveryCharges,
          distanceInMiles: this.distanceInMiles,
          type: this.orderType,
        }, this.$router)
          .then((res) => {
            if (!res.success) {
              this.warn = this.$lang.errors.calculateServer;
              resolve();
              return;
            }
            this.total = res.body.totalAmountWithoutDiscount;
            this.itemsTotal = res.body.itemsTotalAmount;
            resolve();
          });
      });
    },
    calcTotalOffline() {
      this.total = this.cart.length === 0
        ? 0
        : this.cart.reduce(
          (total, current) =>
            total +
                  this.$store.state.calculatePrice(
                    current.selectedSize,
                    current.selectedVariants,
                    current.selectedOptions,
                    current.quantity,
                    current.quantityOfIncludedOptions,
                  ),
          0,
        );
      this.itemsTotal = this.total;
    },
    calcTotalWithoutDelivery() {
      return new Promise((resolve) => {
        const data = {
          items: this.cart.map((current, index) => ({ ...current, itemId: index })),
          type: this.orderType,
        };
        this.$webHelper.post('order/calculatetotalamount', data, this.$router)
          .then((res) => {
            if (!res.success) {
              resolve(null);
              return;
            }
            resolve(res.body.itemsTotalAmount);
          })
          .catch(() => {
            resolve(null);
          });
      });
    },
    calcAll(delivery) {
      return new Promise((resolve) => {
        if (this.cart.length === 0) {
          this.total = 0;
          this.deliveryCharges = 0;
          resolve(false);
          return;
        }
        if (delivery && !this.postalcode) {
          resolve(false);
          return;
        }
        this.calcTotalOffline();
        if (this.orderType === 'delivery' && this.postalcode && (this.deliveryCharges !== null || delivery)) {
          this.calcDelivery()
            .then((res) => {
              if (!res) {
                resolve(false);
                return;
              }
              this.calcTotal()
                .then(() => {
                  resolve(true);
                });
            });
        } else {
          this.distanceInMiles = 0;
          this.deliveryCharges = 0;
          this.calcTotal()
            .then(() => {
              resolve(true);
            });
        }
      });
    },
    testPostalCodeRules(country, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return zip.length > 5 && zip.length < 16;
      }
      if (country === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    clearPostalCodeSearch() {
      this.search = null;
      this.postalCodes = [];
      this.hint = '';
    },
    async isCompeteAddressCheck() {
      if (this.company.address.country === 'AT') {
        // eslint-disable-next-line max-len
        return !!((this.chosenAddress &&
            (this.chosenAddress.line1 && this.chosenAddress.line1 !== '' && this.chosenAddress.line2 && this.chosenAddress.line2 !== '' && this.chosenAddress.townCity && this.chosenAddress.townCity !== '')));
      }
      // eslint-disable-next-line max-len
      return !!((this.chosenAddress &&
          (this.chosenAddress.line1 && this.chosenAddress.line1 !== '' && this.chosenAddress.townCity && this.chosenAddress.townCity !== '')));
    },
    startErrorAnimation(elementId) {
      const el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(() => {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    scrollToHeaderPostal() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 0);
      } else {
        setTimeout(() => {
          const cumulativeOffset = (element) => {
            let top = 0;
            let left = 0;
            do {
              top += element.offsetTop || 0;
              left += element.offsetLeft || 0;
              // eslint-disable-next-line no-param-reassign
              element = element.offsetParent;
            } while (element);
            return {
              top,
              left,
            };
          };
          const postalElement = document.getElementById('elPostalAutocomplete');
          const postalPosition = cumulativeOffset(postalElement);
          window.scrollTo({
            top: postalPosition.top - 120,
            behavior: 'smooth',
          });
        }, 0);
      }
    },
    async submit() {
      this.err = '';
      if (this.comment && this.comment.length > 1024) return;
      if ((this.closed || this.closedMessage) && this.remainingWorkingRanges === 0) return;
      if (!this.company) return;
      if (this.company.webShopResourceStatus !== 'active') return;
      if (this.orderType === 'delivery' && this.company.minDeliveryAmount && this.itemsTotal < parseFloat(this.company.minDeliveryAmount)) {
        this.err = `${this.$lang.errors.totalOver} ${parseFloat(this.company.minDeliveryAmount)
          .toFixed(2)} ${this.$lang.errors.thisDelivery}`;
        return;
      }
      const isCompeteAddress = await this.isCompeteAddressCheck();
      if (this.orderType === 'delivery' && (!isCompeteAddress || !this.postalcode || this.validPostal === false)) {
        this.err = this.$lang.errors.validPostalOrAddress;
        this.startErrorAnimation('el-0');
        this.startErrorAnimation('el-1');
        this.startErrorAnimation('el-3');
        this.startErrorAnimation('elPostalAutocomplete');
        // document.getElementById('postalAutocomplete')
        //   .focus();
        this.scrollToHeaderPostal();
        return;
      }
      if (this.cart.length === 0) {
        this.err = this.$lang.errors.oneItemMinimum;
        return;
      }
      this.$router.push({ name: 'orderInfo', params: { isCompeteAddress } });
    },
    setOrderTypeOnLoad() {
      const type = localStorage.getItem('delivery_method');
      let orderTypes = null;
      if (this.company && this.company.orderTypes) {
        orderTypes = this.company.orderTypes;
      }
      if (type) return type;
      if (orderTypes) {
        if (orderTypes.includes('delivery')) return 'delivery';
        return orderTypes[0];
      }
      return 'delivery';
    },
  },
  created() {
    const cart = this.$storage.order;
    this.orderType = this.setOrderTypeOnLoad();
    this.$store.dispatch('setType', this.orderType);
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (cart) {
      this.$store.dispatch('setCart', cart);
    }
    if (this.storedComment) {
      this.comment = this.storedComment;
    }
    if (this.savedpostalCode && this.orderType === 'delivery') {
      if (this.$route.params.fromBack) {
        this.fromBack = true;
        this.submitAddress(this.$route.params.address);
      }
      if (this.cart.length > 0) {
        this.calcAll(true);
      }
    }

    if (!auth.isLoggedIn()) return;
    if (auth.isAdmin()) return;
    // eslint-disable-next-line max-len
    if ((!this.addresses || this.addresses.length === 0) && !this.addressesSet && !this.isFetchingUser) {
      this.$webHelper.get('contact/fetchforauser', null, this.$router)
        .then((res) => {
          if (!res.success) {
            this.err = this.$lang.errors.failedContactInfo;
            return;
          }
          this.$store.dispatch('setAddresses', res.body.contact.address);
          this.$store.dispatch('setContact', {
            lastName: res.body.contact.lastName,
            phone: res.body.contact.phone,
          });
          this.$store.dispatch('setIntercomUser', {
            lastName: res.body.contact.lastName,
            email: res.body.contact.email,
          });
          if (this.$route.params.address !== '') {
            this.selectAddress = this.generateFullAddress(this.$route.params.address);
          }
        });
    } else if (this.$route.params.address !== '') {
      this.selectAddress = this.generateFullAddress(this.$route.params.address);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
.ahashakeheartache {
  -webkit-animation: kf_shake 0.4s 1 linear;
  -moz-animation: kf_shake 0.4s 1 linear;
  -o-animation: kf_shake 0.4s 1 linear;
}
@-webkit-keyframes kf_shake {
  0% { -webkit-transform: translate(30px); }
  20% { -webkit-transform: translate(-30px); }
  40% { -webkit-transform: translate(15px); }
  60% { -webkit-transform: translate(-15px); }
  80% { -webkit-transform: translate(8px); }
  100% { -webkit-transform: translate(0px); }
}
@-moz-keyframes kf_shake {
  0% { -moz-transform: translate(30px); }
  20% { -moz-transform: translate(-30px); }
  40% { -moz-transform: translate(15px); }
  60% { -moz-transform: translate(-15px); }
  80% { -moz-transform: translate(8px); }
  100% { -moz-transform: translate(0px); }
}
@-o-keyframes kf_shake {
  0% { -o-transform: translate(30px); }
  20% { -o-transform: translate(-30px); }
  40% { -o-transform: translate(15px); }
  60% { -o-transform: translate(-15px); }
  80% { -o-transform: translate(8px); }
  100% { -o-origin-transform: translate(0px); }
}
.required .v-label::after {
  content: ' *';
  color: #d84315;
}
</style>

<style lang="scss" scoped>
.sub-header {
  flex: 0.2 1 auto;
}

thead {
  background-color: white;
}

table.table thead tr {
  height: 44px;
}

tr {
  &.item:nth-of-type(even) {
    background-color: #f3f3f3;
  }

  &.item.is-selected,
  &.item.is-selected:hover {
    td {
      background: rgba($color: #dcdcdc, $alpha: 0.6);
      font-weight: 700;
    }
  }
}

.details {
  font-size: 0.85em;
  color: rgba(0, 0, 0, 0.5);
}

.price {
  min-width: 56px;
  display: inline-block;
  margin: 0;
  padding-left: 8px;
  position: relative;
  text-align: right;
  font-size: 0.85em;
  color: rgba(0, 0, 0, 0.6);

  &:before {
    content: attr(data-currency);
    position: absolute;
    left: 0;
  }

  &.no-min {
    min-width: 1px;
  }
}

.quantity {
  display: inline-block;
  width: 24px;
  height: 24px;
  text-align: center;
}

.total {
  font-size: 13px;
}

@media only screen and (max-width: 768px) {
  .sub-header {
    width: 100% !important;
  }
}

.success {
  position: fixed;
  bottom: -16px;
  left: 0;
  width: 100%;
  margin-bottom: 0;
  z-index: 1000000;
}
</style>

<style lang="scss">
.short-name {
  min-width: 130px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.mini-shopping-basket {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  h5 {
    font-family: 'Roboto', cursive;
    font-weight: 300;
    font-size: 18px;
    cursor: pointer;
  }
}

.add-address {
  font-size: 1.1rem;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.pointerCursor {
  cursor: pointer;
}

.orangeTheme {
  color: #efa546 !important;
}

@media only screen and (max-width: 959px) {
  .v-toolbar__content, .v-toolbar__extension {
    padding: 0 8px !important;
  }
}

.sticky-button {
  padding: 0 8px !important;
  margin: 0 0 0 6px !important;
}

.mobile-card {
  display: none;
}

.desktop-card {
  display: block;
}

@media only screen and (max-width: 600px) {
  .mobile-card {
    display: block;
  }

  .desktop-card {
    display: none;
  }
}

.v-alert .v-alert__icon.v-icon, .v-alert__dismissible .v-icon {
  align-self: start !important;
  padding-top: 2px;
}

.notifications {
  font-size: 26px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/ShoppingBasket.vue